import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a90def78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Question__Inner section__inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Question__Background color--4" }, null, -1))
const _hoisted_3 = { class: "Question__Subinner section__subinner" }
const _hoisted_4 = { class: "Question__Category" }
const _hoisted_5 = { class: "color--1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "base" }
const _hoisted_8 = { class: "hover color--1" }
const _hoisted_9 = { class: "color--4" }
const _hoisted_10 = { class: "wrong" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-wrong" })
], -1))
const _hoisted_12 = { class: "correct" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-correct" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({ 'Question': true, 'is-answered': _ctx.answerIndex !== null, 'wait-answer': !_ctx.isCorrected, 'show-correction': _ctx.isCorrected })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('chapter.trivia')), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.slide.title), 1),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slide.options.filter(item => item.text), (option, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `slide-question-${_ctx.index}-${i}`
            }, [
              _createElementVNode("button", {
                onClick: (event) => { _ctx.onClick(event, i); },
                class: _normalizeClass({ 'answer': !_ctx.isCorrected && _ctx.answerIndex === i, 'correct': _ctx.isCorrected && option.isCorrect, 'wrong': _ctx.isCorrected && !option.isCorrect && _ctx.answerIndex === i })
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(option.text), 1),
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(option.text), 1)
                ]),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", null, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(option.text), 1)
                  ])
                ]),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("span", null, [
                    _hoisted_13,
                    _createTextVNode(_toDisplayString(option.text), 1)
                  ])
                ])
              ], 10, _hoisted_6)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}